module.exports = __webpack_public_path__ + "static/media/profile.2832b756.jpg";